import { unreachable } from 'utils/unreachable';
import { FieldType } from '../fields';
import { FieldFilter } from '../filters';
import { AssigneeFieldFilter } from '../filters/assignee';
import { BooleanFieldFilter } from '../filters/boolean';
import { DateFieldFilter } from '../filters/date';
import { EstimateFieldFilter } from '../filters/estimate';
import { MultiSelectFieldFilter } from '../filters/multi-select';
import { MultiUserFieldFilter } from '../filters/multi-user';
import { NumberFieldFilter } from '../filters/number';
import { SingleSelectFieldFilter } from '../filters/single-select';
import { SingleUserFieldFilter } from '../filters/single-user';
import { TextFieldFilter } from '../filters/text';
import { assignee } from './assignee';
import { boolean } from './boolean';
import { date } from './date';
import { estimate } from './estimate';
import { multi_select } from './multi-select';
import { multi_user } from './multi-user';
import { number } from './number';
import { project_phase } from './project-phase';
import { single_select } from './single-select';
import { single_user } from './single-user';
import { task_dependency_status } from './task_dependency_status';
import { text } from './text';

export interface FilterFunction {
  (record: Record<string, unknown>): boolean;
}

export const toFilterFunction = (filter: FieldFilter): FilterFunction => {
  if (filter.field.fieldName === 'projectPhaseId') {
    return project_phase(filter as SingleSelectFieldFilter);
  }
  if (filter.field.fieldName === 'taskDependencyStatus') {
    return task_dependency_status(filter as SingleSelectFieldFilter);
  }
  switch (filter.field.type) {
    case FieldType.Boolean:
      return boolean(filter as BooleanFieldFilter);
    case FieldType.Number:
      return number(filter as NumberFieldFilter);
    case FieldType.Text:
    case FieldType.MultiLineText:
      return text(filter as TextFieldFilter);
    case FieldType.Date:
      return date(filter as DateFieldFilter);
    case FieldType.SingleSelect:
      return single_select(filter as SingleSelectFieldFilter);
    case FieldType.MultiSelect:
      return multi_select(filter as MultiSelectFieldFilter);
    case FieldType.SingleUser:
      return single_user(filter as SingleUserFieldFilter);
    case FieldType.MultiUser:
      return multi_user(filter as MultiUserFieldFilter);
    case FieldType.Assignee:
      return assignee(filter as AssigneeFieldFilter);
    case FieldType.Estimate:
      return estimate(filter as EstimateFieldFilter);
    default:
      return unreachable(filter.field);
  }
};
